import { Hostspot, addLayoutToRoute } from './base_route'

const routes = [
     {
          path: '/guest/s/default/',
          name: 'Hostspot',
          meta: {
               ...Hostspot,
               folderData: 'default'
          },
          component: () => import('@/views/Hostspot/index.vue'),
          props: true,
     },
     {
          path: '/guest/s/prueba/',
          name: 'Hostspot',
          meta: {
               ...Hostspot,
               folderData: 'prueba'
          },
          component: () => import('@/views/Hostspot/index.vue'),
          props: true,
     },
]
const router_hostspot =  routes.map((route) => addLayoutToRoute(route))  
export { router_hostspot }; 